// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class UpsearchModelSiteSiteUpsearchModel {
    static getAttributeTypeMap() {
        return UpsearchModelSiteSiteUpsearchModel.attributeTypeMap;
    }
}
UpsearchModelSiteSiteUpsearchModel.discriminator = undefined;
UpsearchModelSiteSiteUpsearchModel.additionalProperties = false;
UpsearchModelSiteSiteUpsearchModel.attributeTypeMap = [
    {
        "name": "canUpdate",
        "baseName": "canUpdate",
        "type": "boolean"
    },
    {
        "name": "canInsert",
        "baseName": "canInsert",
        "type": "boolean"
    },
    {
        "name": "skipSearch",
        "baseName": "skipSearch",
        "type": "boolean"
    },
    {
        "name": "model",
        "baseName": "model",
        "type": "SiteUpsearchModel"
    },
];
//# sourceMappingURL=upsearchModelSiteSiteUpsearchModel.js.map